const toolConfig = {
    colors: {
        name:"Stroke Color",
        data:["#000000", "#1971c2", "#9141ac", "#ed333b", "#ff7800"]
    }, 
    background:{
        name:"Background",
        data:["", "#ffec99","#e9ecef" , "#b2f2bb","#fcc2d7"]
    },
    width: {
        name:"Stroke Width",
        data: [2,5,7]
    }, 
    fill: {
        name:"Fill",
        data:["hachure","solid", "zigzag"]
    }, 
    style:{
        name:"Style",
        data:[]
    }
}

export default toolConfig